import React from "react";
import "../Assets/styles/newStyles/Login.css";
import Swaasa from "../Assets/images/Swaasa Logo.svg";
import GooglePlayStore from "../Assets/images/google-icon.svg";
import AppleIcon from "../Assets/images/apple-icon.svg";
import Eye from "../Assets/images/Eye.svg";
import EyeClosed from "../Assets/images/EyeClosed.svg";
import { connect } from "react-redux";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInput from "react-phone-number-input";
import ClipLoader from "react-spinners/ClipLoader";
import { NotificationManager } from "react-notifications";
import history from "../history";
import OtpInput from "react-otp-input";
import { userLogin, clearLoginError } from "../Actions";
import "react-phone-number-input/style.css";
// import GoogleLogin from "../Assets/images/GoogleLogin.svg";
// import AppleLogin from "../Assets/images/AppleLogin.svg";
import LoginEllipse1 from "../Assets/images/login-ellipse-1.svg";
import LoginEllipse2 from "../Assets/images/login-ellipse-2.svg";
import LoginEllipse3 from "../Assets/images/login-ellipse-3.svg";
import axios from "../axios";
import { jwtDecode } from "jwt-decode";


export const Login = (props) => {
  const [tab, setTab] = React.useState("username-tab");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [emailError, setEmailError] = React.useState("");
  const [secondsRemaining, setSecondsRemaining] = React.useState(30);
  const [isTimerRunning, setIsTimerRunning] = React.useState(false);
  const [codeValue, setCodeValue] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [phoneError, setPhoneError] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [isOtpSent, setIsOtpSent] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [otpError, setOtpError] = React.useState('')
  const [otpLoading , setOtpLoading] = React.useState(false)

  const handlePhoneChange = (value) => {
    setPhone(value);
    setIsOtpSent(false);
    setIsTimerRunning(false);
    setPhoneError('')
    setOtpError('')
  };

  const handleOtpChange = (value) => {
    console.log(value);
    setOtp(value);
    setOtpError('')
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const forgotPassword = () => {
    window.open('/forgotPassword', '_blank');

  }

  React.useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        fetch(`https://ipapi.co/${data.ip}/json/`)
          .then((response) => response.json())
          .then((data) => {
            // console.log(data.country_code);
            setCodeValue(data.country_code);
          })
          .catch(() => console.log(""));
      })
      .catch(() => console.log(""));
  }, []);

  // for resend timer

  React.useEffect(() => {
    if (isTimerRunning) {
      const intervalId = setInterval(() => {
        setSecondsRemaining((prevSeconds) => Math.max(0, prevSeconds - 1));
      }, 1000); 

      return () => clearInterval(intervalId); 
    }
  }, [isTimerRunning]);

  const formattedTime =
    secondsRemaining < 10
      ? `0:0${secondsRemaining}`
      : `${Math.floor(secondsRemaining / 60)}:${secondsRemaining % 60}`;
  const clickUsernameTab = (e) => {
    e.preventDefault();
    setTab("username-tab");
  };

  const clickMobileTab = (e) => {
    e.preventDefault();
    setTab("mobile-tab");
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError('')
    if (props.error) {
      props.clearLoginError();
    }
    
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
  
    // Remove spaces and limit to 20 characters
    if (newPassword.length <= 20 && !newPassword.includes(" ")) {
      setPassword(newPassword);
      if (props.error) {
        props.clearLoginError();
      }
    }
  };
  

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (tab === "username-tab") {
      setEmailError("");
      const emailError = !validateEmail(email) ? "Invalid email format" : "";
      setEmailError(emailError);
      setIsLoading(true);

      if (!emailError) {
        try {
          let formData = new FormData();
          formData.append("loginId", email);
          formData.append("password", password);

          await props.userLogin(formData, email);
        } catch (error) {
          console.error("Login API error:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        console.error("Email validation error:", emailError);
        setIsLoading(false);
      }
    } else if (tab === "mobile-tab") {
      setOtpLoading(true);
      try {
        console.log(phone);
        const data = {
          mobile_number: phone,
          otp: otp,
        };
        const response = await axios.post(
          "/mobile_otp",
          data
        );
        console.log(response);
        setOtpLoading(false);
        if (response.data.role == "doctor") {
          localStorage["accessToken"] = response.data.accessToken;
          localStorage.setItem("doctorId", phone);
          localStorage["user"] = response.data.role;
          localStorage["labelling"] = response.data.appConfiguration.labelling;
          localStorage["adminId"] = response.data.appConfiguration.userId;
          localStorage["validation"] = response.data.appConfiguration.validation;
          localStorage["name"] = response.data.firstname;
          localStorage["role"] = response.data.role[0];
          localStorage['accessType'] = response.data.accessType
          localStorage['lhi']= response.data.appConfiguration.hasOwnProperty('lhi')? response.data.appConfiguration.lhi.toString(): 'true'
          localStorage["ageValid"]= response.data.appConfiguration.age_valid;
          localStorage["patientPayment"] = response.data.appConfiguration.patient_payment;
          localStorage["export_data"] =
            response.data.appConfiguration?.export_data;
          localStorage["plan"] = response.data.plan.find(
            (element) => element == "covid"
          );
          
          localStorage["Tb"] = response.data.plan.find(
            (element) => element == "tb"
          );

          localStorage["copd"] = response.data.plan.find(
            (element) => element == "copd"
          );
          localStorage["asthma"] = response.data.plan.find(
            (element) => element == "asthma"
          );

          localStorage["spirometry"] = response.data.plan.find(
            (element) => element == "spirometry"
          );
          localStorage["assessments_tab"] =
            response.data.appConfiguration.assessments_tab;
          localStorage["rpm"] = response.data.plan.find(
            (element) => element === "rpm"
          );
          // localStorage["fev1fvc_2_value"] = response.plan.find(element => element === "spirometry");
          // localStorage["fvc_3_value"] = response.plan.find(element => element === "spirometry");
          // localStorage["fev1_3_value"] = response.plan.find(element => element === "spirometry");

          localStorage["sharedPatient"] =
            response.data.appConfiguration.shared_patient;
          localStorage["bulkupload"] =
            response.data.appConfiguration.bulkupload;
          localStorage["longitudinal_study"] =
            response.data.appConfiguration.longitudinal_study;
          localStorage["timezone"] = response.data.timezone;
          localStorage["filters"] = response.data.appConfiguration.filters;
          localStorage["search"] = response.data.appConfiguration.search;

          try{
            const token = response.data.accessToken;
            const decoded = jwtDecode(token);
            console.log(decoded);
            const userGroup = decoded.user_group;
            
            // Check if any string contains the word 'clinics'
            const containsClinics = userGroup.some((element) => element.includes("clinics"));
            localStorage["clinics"] = containsClinics;
            
            console.log(containsClinics);
          }catch(e){
    console.log("jwt decoding error");
    localStorage["clinics"] = false;
          }
          if (
            localStorage.validation !== "true" ||
            localStorage.longitudinal_study === "true"
          ) {
            history.push("/home");
          } else if (localStorage.validation === "true"&&localStorage.longitudinal_study !== "true") {
            history.push("/validationHome");
          } else {
            history.push("/home");
          }
        } else if (response.data.role == "admin") {
          localStorage["accessToken"] = response.data.accessToken;
          localStorage["user"] = response.data.role;
          localStorage["doctorId"] = email;
          localStorage["sharedPatient"] =
            response.data.appConfiguration.shared_patient;
          localStorage["bulkupload"] =
            response.data.appConfiguration.bulkupload;
          localStorage["filters"] = response.data.appConfiguration.filters;
          localStorage["search"] = response.data.appConfiguration.search;
          localStorage["ageValid"]= response.data.appConfiguration.age_valid;
          localStorage["patientPayment"] = response.data.appConfiguration.patient_payment;
          localStorage["assessments_tab"] =
            response.data.appConfiguration.assessments_tab;

      try{
        const token = response.data.accessToken;
        const decoded = jwtDecode(token);
        console.log(decoded);
        const userGroup = decoded.user_group;
        
        // Check if any string contains the word 'clinics'
        const containsClinics = userGroup.some((element) => element.includes("clinics"));
        localStorage["clinics"] = containsClinics;
        
        console.log(containsClinics);
      }catch(e){
console.log("jwt decoding error");
localStorage["clinics"] = false;
      }
            localStorage['accessType'] = response.data.accessType
            localStorage["plan"] = response.data.plan.find(
              (element) => element == "covid"
            );
            localStorage["Tb"] = response.data.plan.find(
              (element) => element == "tb"
            );
  
            localStorage["copd"] = response.data.plan.find(
              (element) => element == "copd"
            );
            localStorage["asthma"] = response.data.plan.find(
              (element) => element == "asthma"
            );
  
            localStorage["spirometry"] = response.data.plan.find(
              (element) => element == "spirometry"
            );
          history.push("/admindashboard");
          
        } else if (response.data.role == "superadmin") {
          // NotificationManager.success("Login Success", "Success", 2000);
          localStorage["accessToken"] = response.data.accessToken;
          localStorage["user"] = response.data.role;
          localStorage["doctorId"] = email;
          localStorage["plan"] = null;
          localStorage["Tb"] = null;
          localStorage["name"] = response.data.firstname;
          localStorage["role"] = response.data.role[0];
          localStorage["assessments_tab"] =
            response.data.appConfiguration.assessments_tab;

            try{
              const token = response.data.accessToken;
              const decoded = jwtDecode(token);
              console.log(decoded);
              const userGroup = decoded.user_group;
              
              // Check if any string contains the word 'clinics'
              const containsClinics = userGroup.some((element) => element.includes("clinics"));
              localStorage["clinics"] = containsClinics;
              
              console.log(containsClinics);
            }catch(e){
      console.log("jwt decoding error");
      localStorage["clinics"] = false;
            }
          localStorage["copd"] = null;
          localStorage["asthma"] = null;
          localStorage['accessType'] = response.data.accessType
          localStorage["spirometry"] = null;
          localStorage["patientPayment"] = response.data.appConfiguration.patient_payment;


          localStorage["sharedPatient"] =
            response.data.appConfiguration.shared_patient;
          localStorage['lhi']= response.data.appConfiguration.hasOwnProperty('lhi')? response.data.appConfiguration.lhi.toString(): 'true'
          localStorage["bulkupload"] =
            response.data.appConfiguration.bulkupload;
          localStorage["export_data"] =
            response.data.appConfiguration?.export_data;
          localStorage["timezone"] = response.data.timezone;
          localStorage["filters"] = response.data.appConfiguration.filters;
          localStorage["search"] = response.data.appConfiguration.search;
          localStorage["ageValid"]= response.data.appConfiguration.age_valid;
          history.push("/superadmin");
        } 
        else {
          // NotificationManager.success("Login Success", "Success", 2000);
          localStorage["accessToken"] = response.data.accessToken;
          localStorage["user"] = response.data.role;
          localStorage["doctorId"] = email;
          localStorage["plan"] = null;
          localStorage["Tb"] = null;
          localStorage["assessments_tab"] =
            response.data.appConfiguration.assessments_tab;
          localStorage["copd"] = null;
          localStorage["asthma"] = null;

          try{
            const token = response.data.accessToken;
            const decoded = jwtDecode(token);
            console.log(decoded);
            const userGroup = decoded.user_group;
            
            // Check if any string contains the word 'clinics'
            const containsClinics = userGroup.some((element) => element.includes("clinics"));
            localStorage["clinics"] = containsClinics;
            
            console.log(containsClinics);
          }catch(e){
    console.log("jwt decoding error");
    localStorage["clinics"] = false;
          }
          localStorage["spirometry"] = null;
          localStorage["name"] = response.data.firstname;
          localStorage["role"] = response.data.role[0];

          localStorage["sharedPatient"] =
            response.data.appConfiguration.shared_patient;
           localStorage['lhi']= response.data.appConfiguration.hasOwnProperty('lhi')? response.data.appConfiguration.lhi.toString(): 'true'
          localStorage["labelling"] = response.data.appConfiguration.labelling;
          localStorage["bulkupload"] = 
            response.data.appConfiguration.bulkupload;
          localStorage["export_data"] =
            response.data.appConfiguration?.export_data;
          localStorage["timezone"] = response.data.timezone;
          localStorage["filters"] = response.data.appConfiguration.filters;
          localStorage["search"] = response.data.appConfiguration.search;
          localStorage["patientPayment"] = response.data.appConfiguration.patient_payment;
          history.push("/admindashboard");
     
        }
      } catch (error) {
        setOtpLoading(false)
        let errorMessage = 'Please try logging in after some time.';
      
        if (error.response) {
         if (error.response.data.message === 'No Item found') {
                errorMessage = 'Try to resend OTP.';
                setOtpError(errorMessage)
            } 
          else {
              errorMessage = error.response.data.message;
              setOtpError(errorMessage)
            }
          } else if (error.response.status === 500) {
            errorMessage = 'Please try logging in after some time.';
            setOtpError(errorMessage)
          }
        }
        
      
    }
  };

  const sendOtp = async () => {
    setPhoneError(false);
    setIsOtpSent(false);
    setOtp("");
    setOtpError('')
    setIsTimerRunning(false)

    if (!isValidPhoneNumber(phone)) {
      setPhoneError(true);
      return;
    }

    setOtpLoading(true)

    const data = { mobile_number: phone };

    try {
      const response = await axios.post(
        "/mobileLogin",
        data,
        { headers: { "Content-Type": "application/json" } }
      );
    
      if (response.data.status === "SUCCESS") {
        setIsOtpSent(true);
        setSecondsRemaining(30);
        setIsTimerRunning(true);
        setOtpLoading(false);
      }
    } catch (error) {
      setOtpLoading(false)
      let errorMessage = 'Please try logging in after some time.';
    
      if (error.response) {
        if (error.response.data.message) {
          if (error.response.data.message === 'Login limit exceeded') {
            errorMessage = 'Too many login attempts. Please try logging in after some time.';
            setOtpError(errorMessage)
          } else if (error.response.data.message === 'No user data found with the given details, please sign up.') {
            errorMessage = 'No user found. Please verify the mobile number.';
            setOtpError(errorMessage)
           } else if (error.response.data.message === 'No item found') {
              errorMessage = 'Try to resend OTP.';
              setOtpError(errorMessage)
          } else {
            errorMessage = error.response.data.message;
            setOtpError(errorMessage)
          }
        } else if (error.response.status === 500) {
          errorMessage = 'Please try logging in after some time.';
          setOtpError(errorMessage)
        }
      }
      
    }
  }

  



  const goToSupport = () => {
    window.open('https://swaasa.ai/solutions/', '_blank');
  }

  const goToContactus = () => {
      window.open('https://swaasa.ai/contact-us/', '_blank');
  }
  const goToPrivacyPolicy = () => {
    window.open('https://7jx.d89.myftpupload.com/privacy-policy/', '_blank');
  }

  const goToAppleStore=()=>{
    window.open('https://apps.apple.com/us/app/swaasa/id1529923164', '_blank');
  }

  const goToGoogleStore=()=>{
    window.open('https://play.google.com/store/apps/details?id=com.swaasa.app&hl=en&gl=US', '_blank');
  }

// console.log(props.error)

  return (
    <>
      <div className="main-login-container">
        <div className="header-container">
          <div>
            <img src={Swaasa} className="image-logo" alt="swaasa" />
          </div>
        </div>
        <div className="login-form-container">
          <img src={LoginEllipse2} className="login-ellipse2" alt="ellipse-2" />
          <div style={{ display: "flex" }}>
            <form className="form-container" onSubmit={handleSubmit}>
              <h1 className="login-heading">Login With</h1>
              <div style={{ display: "flex", gap: "34px" }}>
                <button
                  className={
                    tab === "username-tab" ? "active-email" : "tab-email-button"
                  }
                  onClick={clickUsernameTab}
                >
                  Username
                </button>
                <button
                  className={
                    tab === "mobile-tab" ? "active-email" : "tab-mobile-button"
                  }
                  onClick={clickMobileTab}
                >
                  Mobile
                </button>
              </div>
              <hr className="login-line" />
              {tab === "username-tab" && (
                <div>
                  <div className="input-container">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <label className="input-label" htmlFor="username">
                        Username
                      </label>
                      {emailError && (
                        <p className="error-email">{emailError}</p>
                      )}
                    </div>

                    <input
                      type="text"
                      id="username"
                      name="username"
                      style={
                        emailError
                          ? { color: "var(--Red-Normal, #E63900)" }
                          : { color: "var(--Black, #131313)" }
                      }
                      className="username-input-field"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="Email/Username"
                      required
                    />
                  </div>
                  <div className="password-input-container">
                    <label className="input-label" htmlFor="password">
                      Password
                    </label>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      className="password-input-field"
                      value={password}
                      onChange={handlePasswordChange}
                      placeholder="Password"
                      required
                    />
                    <img
                      src={showPassword ? EyeClosed : Eye}
                      className="eye-icon"
                      alt="eye-icon"
                      onClick={toggleShowPassword}
                    />
                  </div>
                  <p className='error-email' style={{color:'#CF3300', fontSize:'13.5px', marginTop:"6px", fontWeight:'500', width:'320px'}}>{props.error}</p>
                  <p className="forgot-password" onClick={forgotPassword}>
                    Forgot Password?
                  </p>
                  {isLoading ? (
                    <div
                      className="login-button"
                      style={{ textAlign: "center", paddingTop: "8px" }}
                    >
                      <ClipLoader color="white" size={25} />
                    </div>
                  ) : (
                    <button
                      type="submit"
                      onClick={() => setTab("username-tab")}
                      className="login-button"
                      style={{ marginBottom: "0em" }}
                    >
                      Login
                    </button>
                  )}
                </div>
              )}

              {tab === "mobile-tab" && (
                <div>
                  <div className="input-container">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <label className="input-label">Mobile number</label>
                      {phoneError && (
                        <p className="error-email">Please enter valid number</p>
                      )}
                    </div>
                    <div className="mobile-container">
                      <PhoneInput
                        defaultCountry={codeValue}
                        international
                        value={phone}
                        onChange={handlePhoneChange}
                        countryCallingCodeEditable={false}
                      />
                      {isOtpSent ? (
                        <p
                          className="otp-para"
                          style={{ color: "var(--Green-Dark, #3BAE62)" }}
                        >
                          OTP Sent
                        </p>
                      ) : otpLoading ? (
                        <div
                          style={{
                            textAlign: "center",
                            paddingRight: "30px",
                            paddingTop: "10px",
                          }}
                        >
                          <ClipLoader color="orangered" size={22} />
                        </div>
                      ) : (
                        <p onClick={sendOtp} className="otp-para">
                          Send OTP
                        </p>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="input-label" htmlFor="phone">
                      OTP
                    </label>
                    <OtpInput
                      value={otp}
                      onChange={handleOtpChange}
                      numInputs={6}
                      disable={true}
                      renderSeparator={<span></span>}
                      renderInput={(props) => (
                        <input
                          {...props}
                          style={{
                            width: "49px",
                            height: "49px",
                          }}
                        />
                      )}
                      containerStyle="otp-inputs-container"
                      inputStyle="otp-input-container"
                    />
                    <div
                      style={{ display: "flex", marginTop: "5px", gap: "4px" }}
                    >
                      {isOtpSent ? (
                        <p className="resend-para">Didn't receive code?</p>
                      ) : (
                        <></>
                      )}
                  
                      {isTimerRunning ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "58%",
                          }}
                        >
                          <p
                            className="resend-button"
                            style={
                              secondsRemaining === 0
                                ? {
                                    color:
                                      "var(--Brand-Orange-brand-orange-500, #FF7D00)",
                                  }
                                : { color: "var(--Gray-Mid-1, #BBC8D4)" }
                            }
                            onClick={secondsRemaining === 0 ? sendOtp : undefined}
                            
                          >
                            Resend
                          </p>
                          {secondsRemaining === 0 ? (
                            <></>
                          ) : (
                            <p className="set-timer">{formattedTime}</p>
                          )}
                        </div>
                      ) : (
                        <p
                          className="resend-button"
                          style={{ textDecoration: "none" }}
                        >
                          Resend OTP
                        </p>
                      )}                    
                    </div>
                    <p  style={{color:'#CF3300', fontSize:'13.5px', marginTop:"6px", width:'320px', fontWeight:'500'}}>{otpError}</p>
                    {isOtpSent ? (
                      otpLoading ? (
                        <div
                          className="login-button"
                          style={{ textAlign: "center", paddingTop: "8px" }}
                        >
                          <ClipLoader color="white" size={25} />
                        </div>
                      ) : (
                        <button
                          type="submit"
                          onClick={() => {
                            setTab("mobile-tab");
                          }}
                          className="login-button"
                          style={{ marginBottom: "0em" }}
                        >
                          Verify
                        </button>
                      )
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              )}
              {/* 
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <p className="or-line"></p>
                <p className="or">OR</p>
                <p className="or-line"></p>
              </div>

              <div className="login-containers">
                <img src={GoogleLogin} className="login-g" alt="google-login" />
                <img src={AppleLogin} className="login-g" alt="apple-login" />
              </div> */}
              {/* <div className="sign-up">
                <p className="signup-para">
                  New to Swaasa?{" "}
                  <span className="signup-span">Sign up here!</span>
                </p>
              </div> */}
            </form>
            <img
              src={LoginEllipse3}
              alt="login-ellipse3"
              className="login-ellipse3"
            />
          </div>

          <img src={LoginEllipse1} className="login-ellipse1" alt="ellipse-1" />
        </div>
        <div className="footer-container">
          <div className="get-containers">
            <div className="get-container">
              <img
                src={GooglePlayStore}
                className="support-image"
                alt="google"
                onClick={goToGoogleStore}
              />
              <img src={AppleIcon} onClick={goToAppleStore} className="support-image" alt="apple" />
            </div>
          </div>
          <div className="support-containers">
            <h4 className="support-heading" onClick={goToSupport}>SUPPORT</h4>
            <h4 className="support-heading" onClick={goToContactus} >CONTACT US</h4>
            <h4 className="support-heading" onClick={goToPrivacyPolicy}>PRIVACY POLICY</h4>
            <h4 className="support-heading" onClick={goToPrivacyPolicy}>TERMS & CONDITIONS</h4>
            {/* <h4 className="support-heading" onClick={goToTermsAndConditions}>TERMS & CONDITIONS</h4> */}
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  error: state.login.error,
});

export const ConnectedLogin = connect(mapStateToProps, { userLogin, clearLoginError })(Login);